import React, {useEffect, useState} from "react"
import { Link } from "gatsby"
import { Link as ScrollLink } from "react-scroll"

const Footer = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <footer>
      <div className={`page-top ${isScrolled ? '' : 'hidden'}`}>
        <ScrollLink to="page-content" smooth>
          <img
            className="pc"
            src="https://stgokulabweb.blob.core.windows.net/images/footer/page-top.png"
            width={43}
            alt="ページトップへ"
            loading="lazy"
          />
          <img
            className="sp"
            src="https://stgokulabweb.blob.core.windows.net/images/footer/page-top.png"
            width={43}
            alt="ページトップへ"
            loading="lazy"
          />
        </ScrollLink>
      </div>
      <div className="footer-contents">
        <span className="nav-wrap">
          <a href="https://privacymark.jp/" target="_blank" className="pc">
          <img src="https://stgokulabweb.blob.core.windows.net/images/footer/pmark-icon.svg"
               className="p-mark"
               alt="Privacy Mark"/>
          </a>
          <Link to={"/privacy"}>Privacy Policy</Link>
          <Link to={"/contact"}>Contact</Link>
          <Link to={"/company/profile"}>Access</Link>
        </span>
        <p className="copy">
          <a href="https://privacymark.jp/" target="_blank">
            <img src="https://stgokulabweb.blob.core.windows.net/images/footer/pmark-icon.svg"
                                 className="p-mark"
                                 alt="Privacy Mark"/>
          </a>
            © OKULAB, Inc. All Rights Reserved.</p>
      </div>
      {/*/.sns*/}
    </footer>
  )
}
export default Footer
